/* ==========================================================================
   KUL KID — shfw-carousel.js
   Auto-rotating product carousel for SHFW media. Each [data-shfw-slide] holds
   a product (image + caption + data-href). Advances every data-interval ms,
   pauses on hover, updates the CTA href and makes the whole stage clickable to
   the active product. Respects prefers-reduced-motion (no auto-advance).
   ========================================================================== */
(function () {
  if (window.__shfwCarouselInit) return;
  window.__shfwCarouselInit = true;

  var reduce =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initOne(root) {
    if (root.__shfwCarouselDone) return;
    root.__shfwCarouselDone = true;

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-shfw-slide]'));
    if (!slides.length) return;
    var track = root.querySelector('[data-shfw-track]');
    var cta = root.querySelector('[data-carousel-cta]');
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 4000;
    var idx = 0;
    var timer = null;

    function show(i) {
      if (track) {
        // Horizontal slide: move the whole track to the left.
        track.style.transform = 'translateX(' + (-i * 100) + '%)';
      }
      for (var n = 0; n < slides.length; n++) {
        slides[n].classList.toggle('is-active', n === i);
      }
      var href = slides[i].getAttribute('data-href') || '';
      root.setAttribute('data-active-href', href);
      if (cta && href) cta.setAttribute('href', href);
    }

    function next() {
      idx = (idx + 1) % slides.length;
      show(idx);
    }

    function start() {
      if (reduce || slides.length < 2) return;
      stop();
      timer = window.setInterval(next, interval);
    }
    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }

    show(0);

    // Click anywhere on the stage (except the CTA link) goes to the active product.
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-carousel-cta]')) return;
      var href = root.getAttribute('data-active-href');
      if (href) window.location.href = href;
    });

    // Keyboard: Enter / Space activates the focused stage.
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      if (e.target.closest('[data-carousel-cta]')) return;
      e.preventDefault();
      var href = root.getAttribute('data-active-href');
      if (href) window.location.href = href;
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    start();
  }

  function init() {
    document.querySelectorAll('[data-shfw-carousel]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }
})();
